<template>
  <div :class="classNames">
    <CMToolbar class="mui-dialog__header" :title="title" :nav="navOrDeclineItem">
      <CMButton v-bind="actionOrAcceptItem" v-if="actionOrAcceptItem"></CMButton>
    </CMToolbar>
    <section :class="bodyClassNames">
      <slot></slot>
    </section>
    <CMToolbar class="mui-dialog__responses" v-if="(isSizeClassRegular || displayAsContext) && hasActionBar">
      <CMButton
        v-for="(item, index) in responseItems"
        :key="index"
        v-bind="item"></CMButton>
    </CMToolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { WINDOW, APP, CONTEXT } from '../config'
import { SET_TEMPORARY_VIEW_VISIBILITY } from '../modules/mutation-types'
import CMButton from '../components/CMButton'
import CMToolbar from '../components/CMToolbar'

export default {
  props: {
    acceptItem: Object,
    acceptOnEnter: {
      type: Boolean,
      default: true
    },
    actionItem: Object,
    dismissItem: Object,
    navItem: Object,
    displayType: String,
    scrollable: {
      type: Boolean,
      default: false
    },
    title: String
  },
  components: {
    CMButton,
    CMToolbar
  },
  computed: {
    ...mapGetters([
      'isSizeClassCompact',
      'isSizeClassRegular'
    ]),
    actionOrAcceptItem () {
      if (this.actionItem) return this.actionItem

      return this.isSizeClassCompact && !this.displayAsContext && this.acceptItem
    },
    hasActionBar () {
      return this.responseItems.length > 0
    },
    navOrDeclineItem () {
      if (this.navItem) return this.navItem

      return this.isSizeClassCompact && !this.displayAsContext && Object.assign({
        icon: 'close',
        name: 'Cancel',
        fn: () => { this.close() }
      }, this.dismissItem)
    },
    responseItems () {
      const acceptItem = Object.assign({
        type: 'accent'
      }, this.acceptItem)
      const dismissItem = Object.assign({
        name: 'Cancel',
        fn: () => { this.close() }
      }, this.dismissItem)

      let items = []
      if (this.dismissItem) items.push(dismissItem)
      if (this.acceptItem) items.push(acceptItem)
      return items
    },
    bodyClassNames () {
      return {
        'mui-dialog__body': true,
        'mui-dialog--scrollable': this.scrollable,
        'ui__scrollbar--transparent': this.scrollable
      }
    },
    classNames () {
      let obj = {
        'mui-dialog': true,
        'mui-dialog--window': this.displayAsWindow,
        'mui-dialog--app': this.displayAsApp,
        'mui-dialog--context': this.displayAsContext
      }
      return obj
    },
    displayAsWindow () {
      return this.displayType === WINDOW || (
        this.displayType === APP && this.isSizeClassCompact
      )
    },
    displayAsApp () {
      return this.displayType === APP && this.isSizeClassRegular
    },
    displayAsContext () {
      return this.displayType === CONTEXT
    },
    obfuscatorVisibility () {
      return this.$store.state.app.obfuscator.visibility
    }
  },
  methods: {
    close () {
      this.$store.commit(SET_TEMPORARY_VIEW_VISIBILITY, null)
    },
    onKeyDown (ev) {
      var keycode = ((typeof ev.keyCode !== 'undefined' && ev.keyCode) ? ev.keyCode : ev.which)
      if (keycode === 27) this.close()
      if (this.acceptOnEnter && keycode === 13 && this.acceptItem) this.acceptItem.fn()
    }
  },
  mounted () {
    window.addEventListener('keydown', this.onKeyDown)
  },
  destroyed () {
    window.removeEventListener('keydown', this.onKeyDown)
  },
  watch: {
    obfuscatorVisibility () {
      if (this.obfuscatorVisibility === 'hidden') this.close()
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-dialog
  display: flex
  flex-direction: column
  width: 480px
  max-width: 90%
  margin: 40px auto 0
  position: fixed
  background-color: #fff
  border-radius: 3px
  box-shadow: 0 0 0 1px rgba(99, 114, 130, 0.16), 0 4px 8px rgba(27, 39, 51, 0.08)
  top: 0
  left: 0
  right: 0
  z-index: 10000
  &.mui-dialog--window
    border-radius: 0
    height: 100%
    margin: 0
    max-width: 100%
    width: 100%
  &.mui-dialog--app
    max-height: calc(100% - 80px)
    width: 640px
.mui-dialog__header
  background: #fbfbfb
  border-top-left-radius: inherit
  border-top-right-radius: inherit
.mui-dialog__body
  display: flex
  padding: 24px
  &.mui-dialog--scrollable
    overflow-y: auto
    overflow-x: hidden
    padding-top: 16px
    -webkit-overflow-scrolling: touch
  .form-group
    width: 100%
.mui-dialog__responses
  border-bottom-left-radius: inherit
  border-bottom-right-radius: inherit
  border-bottom: none
  .mui-layout-row
    margin: 0 8px
  .mui-dialog--window &
    order: -1
    border-top: none
    border-bottom: 1px solid $borderColor
    // TODO: Resolve why this height must be specified
    min-height: 60px
  .mui-dialog--scrollable &
    border-top: 1px solid $borderColor
.mui-layout-spacer
  flex-grow: 1
</style>



// WEBPACK FOOTER //
// src/components/MUIDialog.vue